export default "__VITE_ASSET__BOrV2PqO__"